import { flow, set, unset } from 'lodash/fp';

import type { LeadFormData } from '../../types';

// @ts-expect-error - Automatic, Please fix when editing this file
const adjustFormValuesForLeadType = ({ leadType, values }) => {
  const marketingOptIn = values?.[`marketingOptIn-${leadType.component}`] ?? false;
  const privacyAgreement = values?.[`privacyAgreement-${leadType.component}`] ?? false;
  return flow(
    set('marketingOptIn', marketingOptIn),
    unset(`marketingOptIn-${leadType.component}`),
    set('privacyAgreement', privacyAgreement),
    unset(`privacyAgreement-${leadType.component}`),
  )(values) as LeadFormData;
};

export default adjustFormValuesForLeadType;
